import { apiCall } from "../utils/api"
import { PopUpType, Promotion } from "booker"

export type PopUpPromotionRequest = {
   popupId?: number | null
   hotelId?: number
   promotionCode?: string
   language?: string,
   audience: 'ALL_VISITORS' | 'LOYALTY_PLAN_MEMBERS' | 'NON_REGISTERED_VISITORS'
}

export type PopUpPromotionResponse = Promotion

export async function getPopUpPromotion(request: PopUpPromotionRequest): Promise<PopUpPromotionResponse | null> {
   const { hotelId, language, popupId, audience } = request
   try {
      const result = await apiCall({
         url: `${process.env.REACT_APP_PUBLIC_HOTELS_API}/promotions/exit-intent${hotelId && hotelId > 0 ? `/${hotelId}` : ''}`,
         method: 'GET',
         params: {
            ...popupId ? { popupId } : {}
         },
         headers: {
            ...(audience ? { 'accept-audience': audience } : {})
         }
      },
         undefined,
         language)
      if (result.status !== 200) {
         throw new Error(`error ${result.status}`)
      }
      return { ...result.data, popupId }
   } catch (error) {
      return null
   }
}

export type PopUpRequest = {
   popupId?: number | null
   promotionCode?: string
   language?: string,
   audience: 'ALL_VISITORS' | 'LOYALTY_PLAN_MEMBERS' | 'NON_REGISTERED_VISITORS'
}

export function clickPopup(popupId: number): void {
   apiCall({
      url: `${process.env.REACT_APP_PUBLIC_HOTELS_API}/popups/${popupId}/click`,
      method: 'POST',
   }).catch(() => { })
}

export async function getPopUpList(request: PopUpRequest): Promise<Array<PopUpType> | null> {
   const { language, popupId, audience } = request
   try {
      const result = await apiCall({
         url: `${process.env.REACT_APP_PUBLIC_HOTELS_API}/popups`,//${hotelId && hotelId > 0 ? `/${hotelId}` : ''}`,
         method: 'GET',
         params: {
            ...popupId ? { popupId } : {}
         },
         headers: {
            ...(audience ? { 'accept-audience': audience } : {}),
            'accept-placement': 'WEBSITE'
         }
      },
         undefined,
         language)
      if (result.status !== 200) {
         throw new Error(`error ${result.status}`)
      }
      return result.data
   } catch (error) {
      return null
   }
}

